export const generateIdFromConditionName = (name) => {
    if (typeof name !== "string") {
        console.warn("slugify: Expected a string, got:", name);
        return null; // Or handle differently (e.g., throw an error)
    }
    return name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
};
  